import { Component, ElementRef, Renderer2, ChangeDetectorRef } from '@angular/core';
import { TooltipPopup } from './tooltip-popup';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 're-tooltip-popup',
  template: "\n    <div class=\"tooltip-arrow\"></div><div class=\"tooltip-inner\" *ngIf=\"content\"><span *ngIf=\"!isTemplateRef(content)\" [innerHTML]=\"content\"></span><ng-template *ngIf=\"isTemplateRef(content)\" [ngTemplateOutlet]=\"content\" [ngTemplateOutletContext]=\"{ $implicit: context }\"></ng-template></div>\n  ",
  styles: ["\n    .tooltip-inner{word-break:break-all;word-wrap:break-word}\n  "],
  host: {
    '[class]': '"tooltip fade  " + placement',
    '[style.display]': '"none"',
    'role': 'tooltip',
    '[@state]': 'animateState',
    '(@state.done)': 'afterVisibilityAnimation($event)'
  },
  animations: [
    trigger('state', [
      state('void', style({ transform: 'scale(0)' })),
      state('initial', style({ transform: 'scale(0)' })),
      state('visible', style({ transform: 'scale(1)' })),
      state('hidden', style({ transform: 'scale(0)' })),
      transition('* => visible', animate('150ms cubic-bezier(0.0, 0.0, 0.2, 1)')),
      transition('* => hidden', animate('150ms cubic-bezier(0.4, 0.0, 1, 1)')),
    ])
  ],
})
export class TooltipPopupComponent extends TooltipPopup {

  constructor(elementRef: ElementRef, renderer: Renderer2, changeDetectorRef: ChangeDetectorRef) {
    super(elementRef, renderer, changeDetectorRef);
  }
}
